import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SubscriptionStyles.css';

function SubscriptionCancelPage() {
  const navigate = useNavigate();

  return (
    <div className="subscription-result-page cancel">
      <div className="result-card">
        <div className="cancel-icon">&#10005;</div>
        <h1>Checkout Canceled</h1>
        <p>Your subscription checkout was canceled. No charges were made.</p>

        <div className="result-details">
          <p>You can always come back and subscribe later when you're ready.</p>
        </div>

        <div className="result-actions">
          <button className="primary-button" onClick={() => navigate('/pricing')}>
            View Plans
          </button>
          <button className="secondary-button" onClick={() => navigate('/')}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default SubscriptionCancelPage;
